module.exports = __webpack_public_path__ + "static/media/Land.cd5ff0ba.png";